import React from 'react';
import { FaCheck } from 'react-icons/fa';

const QuestionCard = ({ question, currentAnswer, onAnswer, questionNumber, totalQuestions }) => {
    const handleOptionClick = (option) => {
        onAnswer(question.id, option.value);
    };

    // Validar que la pregunta tenga opciones
    if (!question || !question.options || !Array.isArray(question.options)) {
        return (
            <div className="bg-white rounded-lg p-6 border border-gray-200">
                <div className="text-center">
                    <div className="text-gray-500 text-4xl mb-4">⚠️</div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">
                        Error en la pregunta
                    </h3>
                    <p className="text-gray-600">
                        No se pudieron cargar las opciones de esta pregunta
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg p-6 border border-gray-200">
            {/* Question Header */}
            <div className="mb-6">
                <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-gray-500">
                        Pregunta {questionNumber} de {totalQuestions}
                    </span>
                    {currentAnswer && (
                        <div className="flex items-center text-green-500 text-sm">
                            <FaCheck className="mr-1" />
                            Respondida
                        </div>
                    )}
                </div>
                <h3 className="text-lg font-semibold text-gray-800 leading-relaxed">
                    {question.question}
                </h3>
            </div>

            {/* Options */}
            <div className="space-y-3">
                {question.options.map((option, index) => (
                    <button
                        key={index}
                        onClick={() => handleOptionClick(option)}
                        className={`w-full p-4 text-left rounded-lg border-2 transition-all duration-200 hover:shadow-md ${currentAnswer === option.value
                            ? 'border-blue-500 bg-blue-50 text-blue-700'
                            : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'
                            }`}
                    >
                        <div className="flex items-center">
                            <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center mr-3 ${currentAnswer === option.value
                                ? 'border-blue-500 bg-blue-500'
                                : 'border-gray-300'
                                }`}>
                                {currentAnswer === option.value && (
                                    <div className="w-2 h-2 bg-white rounded-full"></div>
                                )}
                            </div>
                            <span className="font-medium">{option.text}</span>
                        </div>
                    </button>
                ))}
            </div>

            {/* Help Text */}
            {question.help && (
                <div className="mt-4 p-3 bg-blue-50 rounded-lg">
                    <p className="text-sm text-blue-700">
                        💡 {question.help}
                    </p>
                </div>
            )}
        </div>
    );
};

export default QuestionCard; 